import React from 'react'

export default function Squareone() {
    return (
        <div className='section bg-gradient-new-reverse'>
            <div className='container  '>
                <div className='row'>
                    <div className='col-lg-12 text-center bgimg' style={{paddingBottom:"20rem",borderRadius:"48px"}}>
                        <p className='price1 ' style={{marginTop:"20px"}}>Elevate your profile with 100 AI headshots for just $15</p>
                        <p className="save1"> Level Up Your Profile with AI Magic! Reinvent Yourself and Shine with AI-Powered Headshots! </p>
                        <button className='sqbtn1 mt-4 sqtext'>LEARN MORE</button>
                    </div>
                </div>
            </div>
        </div>
    )
}
